<template>
  <div class="h-screen flex flex-col justify-center items-center bg-gray-100">
    <h1 class="text-3xl font-bold text-gray-800 mb-6">Тавтай морилно уу</h1>
    <el-row :gutter="20" class="w-full max-w-4xl">
      <!-- Тооцоо нийлэх карт -->
      <el-col :span="12">
        <el-card class="rounded-2xl overflow-hidden shadow-lg transition-transform transform hover:scale-105 bg-white">
          <img :src="calculate" class="w-full h-96 object-cover rounded-t-2xl">
          <div class="p-6 text-center">
            <el-button @click="accountant()" class="w-full bg-blue-500 hover:bg-blue-600 text-white font-semibold py-3 rounded-lg transition">
              Тооцоо нийлэх
            </el-button>
          </div>
        </el-card>
      </el-col>

      <!-- TOKTOK Купон карт -->
      <el-col :span="12">
        <el-card class="rounded-2xl overflow-hidden shadow-lg transition-transform transform hover:scale-105 bg-white">
          <img :src="toktok" class="w-full h-96 object-cover rounded-t-2xl">
          <div class="p-6 text-center">
            <el-button @click="toktokCoupon()" class="w-full bg-green-500 hover:bg-green-600 text-white font-semibold py-3 rounded-lg transition">
              TOKTOK Купон
            </el-button>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUserName, getGroups } from '@/utils/auth.js'
import calculate from '../../src/assets/calculate.png'
import toktok from '../../src/assets/toktok.png'
export default {
  created () {
    this.getUser()
  },
  data () {
    return {
      username: '',
      calculate: calculate,
      toktok: toktok
    }
  },
  methods: {
    async getUser () {
      this.username = await getUserName()
      const group = await getGroups()
      if (group.includes('accountant') || group.includes('view')) {
        this.$router.push({ name: 'settlementList' })
      }
    },
    accountant () {
      this.$router.push({ name: 'settlementList' })
    },
    toktokCoupon () {
      this.$router.push({ name: 'discounts' })
    }
  }
}

</script>
<style scoped>
  .image {
    width: 100%;
    display: block;
  }
  .button {
    align-items: center;
    font-size: 0.8vw;
  }
  .card {
    width: 60%;
    margin-left: 20%;
  }
</style>
